/* eslint array-callback-return: 0 */
/* eslint consistent-return: 0 */
import {
    AppIntegrationsRepository,
    MeRepository,
    LicensesRepository,
} from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = ['DeploymentUrlsRestService', '$window', '$timeout',
    '$scope', '$rootScope', 'Util', '$state'];

class WebAppDeploymentController {

    constructor(DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope, Util, $state) {

        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.user = MeRepository.getMyUser();
        this.Util = Util;
        this.LicensesRepository = LicensesRepository;
        this.deployCheck = {
            isEmailValid: false,
            showEmailError: false,
        };

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.osType = Util.deepFind(this.app, 'attributes.custom.manifest.compatibleWithServer') ? 'server' : 'desktop';
        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';

        this.$state = $state;

        eventManager.broadcast('modal.closeBtn:hide');

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();

        }


        this.deployViaRedirect();

    }

    // find and return license from /licenses
    getLicense() {

        // try to get license from LicenseRepository based of app id (case for bundle)
        let licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);

        // license not found, try to find license based on component
        if (typeof licenseData === 'undefined') {

            const allLicenses = this.LicensesRepository.getAll();

            /**
             * Search each appid of each license in appIntegrationRepository
             */
            allLicenses.forEach((license) => {

                // bundle id of each license
                const licenseBundleId = license.relationships.app.data.id;

                // get app integration for the bundle id of license
                const appIntegration = AppIntegrationsRepository.getById(licenseBundleId);

                // stop at first find
                if (!licenseData && this.Util.deepFind(appIntegration, 'relationships.apps')) {

                    // search component to be deployed (from URL) in components of the bundle
                    appIntegration.relationships.apps.data.find((app) => {

                        // component found === license found
                        if (app.id === this.$scope.inputData.appId) {

                            licenseData = license;
                            return true;

                        }

                    });

                }

            });

        }

        return licenseData;

    }

    deployViaRedirect() {

        Mixpanel.send(
            'ConnectWeb Deployment Download Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId,
            },
        );

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            license_number: this.licenseId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

            // success handler

            const downloadUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');
            const appId = this.Util.deepFind(response, 'data.data.attributes.appId');

            if (appId === 'adwp1') {

                this.$timeout(() => {

                    this.$state.go('root.dashboard.dwm', {
                        tab: 'dwm',
                    });

                }, 3000);

            } else if (downloadUrl) {

                this.$timeout(() => {

                    this.$window.location.href = downloadUrl;

                }, 3000);

            } else {

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc',
                    },
                });
                this.Util.closeModal();

            }

        }, () => {

            // error handler

            Alert.error({
                message: 'cw.modal.server-error.desc',
                icon: {
                    cssClasses: 'icon-pc',
                },
            });
            this.Util.closeModal();

        });

    }

}

class WebAppDeploymentDirective {

    constructor() {

        this.template = require('./web-app-deployment.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope,
            Util, $state,
        ) =>
            new WebAppDeploymentController(
                DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope,
                Util, $state,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'webAppDeploymentCtrl';

    }

}

_directiveDependencies.push(() =>
    new WebAppDeploymentDirective());

angular.module('directives')
    .directive('webAppDeployment', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/web-app-deployment/web-app-deployment.js